import { TEST_IDS } from "@/constants/testIds";

const About = () => {
    return (
        <section
            id="about"
            data-testid={TEST_IDS.aboutSection}
            className="relative py-24 md:py-32 bg-white border-y border-hairline"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                    {/* Eyebrow + heading */}
                    <div className="lg:col-span-5">
                        <p className="text-[11px] tracking-[0.3em] uppercase text-navy font-medium mb-6">
                            About
                        </p>
                        <h2
                            data-testid={TEST_IDS.aboutHeading}
                            className="font-serif text-4xl md:text-5xl lg:text-[56px] leading-[1.1] tracking-tight text-ink"
                        >
                            From trading commodities to building{" "}
                            <span className="italic text-navy">connections.</span>
                        </h2>
                    </div>

                    {/* Body */}
                    <div className="lg:col-span-7 lg:pt-3">
                        <p className="text-lg md:text-xl leading-relaxed text-ink/85 font-light">
                            Southern African Traders Ltd began as a commodity trading
                            business. As the digital world evolved, the company redirected
                            its experience and entrepreneurial focus towards creating online
                            platforms with educational, cultural, and social value.
                        </p>
                        <p className="mt-6 text-base md:text-lg leading-relaxed text-muted2">
                            Today, the company owns and develops digital projects designed
                            to encourage dialogue, learning, participation, and greater
                            integration between people and communities — with a particular
                            focus on emerging markets.
                        </p>

                        {/* Pillars */}
                        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-y-6 gap-x-4 border-t border-hairline pt-8">
                            {[
                                { k: "01", v: "Dialogue" },
                                { k: "02", v: "Education" },
                                { k: "03", v: "Culture" },
                                { k: "04", v: "Integration" },
                            ].map((p) => (
                                <div key={p.k}>
                                    <div className="text-[10px] tracking-[0.3em] uppercase text-muted2 mb-2">
                                        {p.k}
                                    </div>
                                    <div className="font-serif text-2xl text-ink">{p.v}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
